module.exports = __webpack_public_path__ + "img/about-bg4-m.137c1b4d.png";